import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Popover, Radio } from 'antd';
import classNames from 'classnames';
import Image from 'next/image';

import styles from './index.module.less';

export enum FilterType {
  FOLLOWER_LATEST = 'latest', // 粉丝数
  FOLLOWING_HOT = 'hot', // 关注数
  FOLLOWER_NUM = 'followerNum', // 粉丝数
  FOLLOWING_NUM = 'followingNum', // 关注数
  POST_NUM = 'postNum', // 发帖数
}

const FilterPopoverContent = memo(
  ({ currentFliterType, onChange }: { currentFliterType: string; onChange: (value: FilterType) => void }) => {
    const { t } = useTranslation('common');

    const list = [
      {
        label: t('Most Followers'),
        value: FilterType.FOLLOWER_NUM,
      },
      {
        label: t('Most Posts'),
        value: FilterType.POST_NUM,
      },
      {
        label: t('Most Following'),
        value: FilterType.FOLLOWING_NUM,
      },
    ];

    return (
      <div className={styles.lists}>
        {list?.map((item) => {
          return (
            <div key={item.value} className={styles.lists__item} onClick={() => onChange(item?.value)}>
              <span
                style={{ fontWeight: currentFliterType === item.value && 700 }}
                className={classNames(styles['lists__item--text'])}
              >
                {item.label}
              </span>
              <Radio checked={currentFliterType === item.value} />
            </div>
          );
        })}
      </div>
    );
  }
);

FilterPopoverContent.displayName = 'FilterPopoverContent';

const FilterPopover = ({ type, onChange }: { type: FilterType; onChange: (type: FilterType) => void }) => {
  const [openPop, setOpenPop] = useState(false);

  useEffect(() => {
    setOpenPop(false);
  }, [type]);

  return (
    <Popover
      getPopupContainer={(e) => e.parentElement}
      rootClassName={styles.container__popover}
      placement="bottomRight"
      arrow={false}
      trigger="click"
      open={openPop}
      content={<FilterPopoverContent currentFliterType={type} onChange={(val) => onChange(val)} />}
    >
      <div
        style={{ background: openPop && 'var(--app-primary-color)' }}
        className={styles.container__filter}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          setOpenPop((prev) => !prev);
        }}
      >
        <Image
          width={24}
          height={24}
          src={`/images/starInfo/filter-icon${openPop ? '-active' : ''}.png`}
          alt="filter-icon"
        />
      </div>
    </Popover>
  );
};

export default FilterPopover;
